module.exports = __webpack_public_path__ + "HRA Flyer.pdf";